// Footer link columns are <details> disclosures on mobile; this keeps them open from the md breakpoint up.
class SFooterAccordion extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const query = window.matchMedia('(min-width: 768px)');
    const sync = () => {
      for (const details of this.querySelectorAll('details')) {
        details.open = query.matches;
      }
    };
    sync();
    query.addEventListener('change', sync, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = null;
  }
}

if (!customElements.get('s-footer-accordion')) {
  customElements.define('s-footer-accordion', SFooterAccordion);
}
